import { z } from 'zod';
/** Every collaborative entity is keyed by an opaque client-generated id (nanoid/uuid). */
export const idSchema = z.string().min(1).max(64);
/** ISO-8601 timestamp, always UTC (e.g. `2026-07-28T18:30:00.000Z`). */
export const isoDateTimeSchema = z.string().datetime({ offset: true });
/** Calendar date without a time component (`YYYY-MM-DD`). */
export const isoDateSchema = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'expected YYYY-MM-DD');
/** Hex colour used for per-member colour coding. */
export const hexColorSchema = z.string().regex(/^#[0-9a-fA-F]{6}$/, 'expected #rrggbb');
/**
 * Provenance stamped on every collaborative record so the UI can say
 * "Mom checked this 2m ago" (ROADMAP §1.3).
 */
export const auditSchema = z.object({
    createdBy: idSchema,
    createdAt: isoDateTimeSchema,
    updatedBy: idSchema,
    updatedAt: isoDateTimeSchema,
});
//# sourceMappingURL=common.js.map